/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import DefaultPredicateComparisonOptions from 'predicates/models/data/default-predicate-comparison-options';
const CustomComparisonOptions = {
  custom: {
    'conversation.team_assignee_id': {
      optionalSelect: {
        comparison: [{
          label: 'is',
          value: 'eq'
        }, {
          label: 'is not',
          value: 'ne'
        }, {
          label: 'is unknown',
          value: 'unknown'
        }, {
          label: 'has any value',
          value: 'known'
        }]
      }
    },
    'conversation.admin_assignee_id': {
      optionalSelect: {
        comparison: [{
          label: 'is',
          value: 'eq'
        }, {
          label: 'is not',
          value: 'ne'
        }, {
          label: 'is unknown',
          value: 'unknown'
        }, {
          label: 'has any value',
          value: 'known'
        }]
      }
    },
    'conversation.conversation_state': {
      optionalSelect: {
        comparison: [{
          label: 'is',
          value: 'eq'
        }, {
          label: 'is not',
          value: 'ne'
        }]
      }
    },
    'conversation.conversation_started_by': {
      optionalSelect: {
        comparison: [{
          label: 'is',
          value: 'eq'
        }, {
          label: 'is not',
          value: 'ne'
        }]
      }
    },
    'conversation.rating_requested_for_actors': {
      optionalSelect: {
        comparison: [{
          label: 'requested for',
          value: 'in'
        }, {
          label: 'not requested for',
          value: 'nin'
        }, {
          label: 'requested for any agent',
          value: 'known'
        }, {
          label: 'not requested for any agent',
          value: 'unknown'
        }]
      }
    },
    'conversation.total_visible_typed_characters': {
      numeric: {
        comparison: [{
          label: 'greater than',
          value: 'gt'
        }, {
          label: 'less than',
          value: 'lt'
        }, {
          label: 'is',
          value: 'eq'
        }, {
          label: 'is not',
          value: 'ne'
        }]
      }
    },
    'message.has_attachments': {
      boolean: {
        comparison: [{
          label: 'is true',
          value: 'true'
        }, {
          label: 'is false',
          value: 'false'
        }]
      }
    },
    'conversation.custom_attribute.brand': {
      optionalSelect: {
        comparison: [{
          label: 'is',
          value: 'eq'
        }, {
          label: 'is not',
          value: 'ne'
        }]
      }
    }
  }
};
let mergedOptions = Object.assign({}, DefaultPredicateComparisonOptions, CustomComparisonOptions);
export default mergedOptions;